import script from "./PublicChatWidgetLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicChatWidgetLoader.vue?vue&type=script&setup=true&lang=js"

import "./PublicChatWidgetLoader.vue?vue&type=style&index=0&id=2a565b22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a565b22"]])

export default __exports__